module.exports = __webpack_public_path__ + "static/media/top.cdecf52a.png";